<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter une TVA</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier une TVA</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-4">
            <mat-form-field class="full-width">
              <mat-label>Code</mat-label>
              <input matInput type="text" formControlName="code" maxlength="2" required>
              <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
              </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="full-width">
              <mat-label>Libelle</mat-label>
              <input matInput name="libelle" formControlName="libelle" maxlength="80" required>
              <mat-error *ngIf="form.get('libelle').hasError('required')">
                  Veuillez saisir un libelle
              </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
            <mat-form-field class="full-width">
              <mat-label>Taux</mat-label>
              <input matInput name="taux" type="number" formControlName="taux" required>
              <mat-error *ngIf="form.get('taux').hasError('required')">
                  Veuillez saisir un taux
              </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
          <mat-label>Compte OD 1 </mat-label>
            <input matInput name="compteOd1" formControlName="compteOd1" maxlength="12">
          </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
            <mat-label>Compte OD 2 </mat-label>
            <input matInput name="compteOd2" formControlName="compteOd2" maxlength="12" required>
            <mat-error *ngIf="form.get('compteOd2').hasError('required')">
              Veuillez saisir un compte OD 2
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
            <mat-label>Compte fact 1</mat-label>
            <input matInput name="compteFact1" formControlName="compteFact1" maxlength="12" required>
            <mat-error *ngIf="form.get('compteFact1').hasError('required')">
              Veuillez saisir un compte Fact 1
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
            <mat-label>Compte compta 1</mat-label>
            <input matInput name="compteCompta" formControlName="compteCompta" maxlength="12" required>
            <mat-error *ngIf="form.get('compteCompta').hasError('required')">
              Veuillez saisir un compte Comptable
            </mat-error>
          </mat-form-field>
        </div>
        

        <div class="col-sm-2">
          <mat-form-field class="full-width" style="float: center;">
            <mat-label>TVA auto-liquidé </mat-label>
            <mat-select formControlName="autoIntra">
              <mat-option [value]="true" >Oui</mat-option>
              <mat-option [value]="false" >Non</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-sm-3">
          <mat-form-field class="full-width">
            <mat-label>Compte fact 2</mat-label>
            <input matInput name="compteFact2" formControlName="compteFact2" maxlength="12" required>
            <mat-error *ngIf="form.get('compteFact2').hasError('required')">
              Veuillez saisir un compte Fact 2
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="col-sm-3">
          <mat-form-field class="full-width">
            <mat-label>Compte compta 2</mat-label>
            <input matInput name="compteCompta2" formControlName="compteCompta2" maxlength="12" required>
            <mat-error *ngIf="form.get('compteCompta2').hasError('required')">
              Veuillez saisir un compte Compta 2
            </mat-error>
          </mat-form-field>
        </div>
        
        
        <!--<div class="col-sm-6">
            <mat-form-field class="full-width">
                <mat-label>Date de validation</mat-label>
                <input matInput [matDatepicker]="pickerD"
                 name="nth-date" formControlName="dValid">
                <mat-datepicker-toggle matSuffix [for]="pickerD"></mat-datepicker-toggle>
                <mat-datepicker #pickerD></mat-datepicker>
            </mat-form-field>
        </div>-->
    </form>
  </div>
  
  <div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
  </div>

